var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalonNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_572",
    "data-name": "Grupo 572",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_571",
    "data-name": "Grupo 571",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3312",
    "data-name": "Trazado 3312",
    d: "M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3313",
    "data-name": "Trazado 3313",
    d: "M31.184,25.633l-8.3-14.681-6.155-3.5A18.745,18.745,0,0,0,7.3,14.787l.815,6.43L4.2,25.894A18.608,18.608,0,0,0,8.112,36.576l6.1.813,3.137,5.59a18.693,18.693,0,0,0,5.533.833Z",
    transform: "translate(-2.884 -5.114)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3314",
    "data-name": "Trazado 3314",
    d: "M72.078,37.1l6.394-.521a18.6,18.6,0,0,0,3.9-10.526l-3.9-4.735.677-6.734a18.743,18.743,0,0,0-9.294-7.126l-6.155,3.5V43.812a18.693,18.693,0,0,0,5.533-.833Z",
    transform: "translate(-43.7 -5.114)",
    fill: "#ebf3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3315",
    "data-name": "Trazado 3315",
    d: "M22.846,29.828l2.494-7.286-2.215-6.47.154-3.745-.168-3.174,1.453-2.768L22.846,4.149a18.67,18.67,0,0,0-6.155,1.038l5.424,3.941v6.659l-6.168,4.481L9.365,18.529l-2.106-6.01a18.611,18.611,0,0,0-3.11,10.327c0,.261.007.521.017.779L9,19.943l6.456,1.706,2.372,7.3L14.24,34.236l-6.166.072a18.726,18.726,0,0,0,9.239,6.4l-1.9-5.608,3.576-5.274h3.852Z",
    transform: "translate(-2.846 -2.846)",
    fill: "#525264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3316",
    "data-name": "Trazado 3316",
    d: "M71.092,21.648l6.3-1.664,4.982,3.8q.023-.465.023-.935a18.61,18.61,0,0,0-3.248-10.533l-2.2,6.277L70.6,20.267l-6.167-4.481V9.127l5.424-3.941A18.665,18.665,0,0,0,63.7,4.148V29.827h3.852L71.128,35.1l-1.9,5.609a18.724,18.724,0,0,0,9.239-6.4l-6.166-.072L68.72,28.947Z",
    transform: "translate(-43.7 -2.846)",
    fill: "#454553"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalonNav);
export default __webpack_public_path__ + "static/media/balonNav.fe34cc4cc89c28dbf59b3c643a75eeb2.svg";
export { ForwardRef as ReactComponent };